import { ScrollReveal } from '@/components/ui/scroll-reveal'
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from '@/components/ui/accordion'
import { FaqItem } from '@/services/content'
import { HelpCircle } from 'lucide-react'

interface SectorFaqSectionProps {
  faqs: FaqItem[]
}

export const SectorFaqSection = ({ faqs }: SectorFaqSectionProps) => {
  // Defensive check: ensure faqs is an array and not empty
  if (!faqs || !Array.isArray(faqs) || faqs.length === 0) return null

  return (
    <section className="py-24 bg-white">
      <div className="container px-4 md:px-6 max-w-4xl mx-auto">
        <ScrollReveal className="text-center mb-16">
          <div className="inline-flex items-center justify-center space-x-2 mb-6 px-4 py-1.5 rounded-full bg-slate-100 text-slate-700 font-medium text-sm">
            <HelpCircle size={16} />
            <span>Dúvidas Comuns</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6">
            Perguntas Frequentes
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto leading-relaxed">
            Esclareça as suas dúvidas específicas sobre a nossa solução para
            este setor.
          </p>
        </ScrollReveal>

        <ScrollReveal delay={200}>
          <Accordion type="single" collapsible className="w-full space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`faq-${index}`}
                className="border border-slate-200 rounded-lg px-6 bg-slate-50 data-[state=open]:bg-white data-[state=open]:border-primary/20 data-[state=open]:shadow-sm transition-all duration-300"
              >
                <AccordionTrigger className="text-left font-semibold text-slate-900 text-lg py-6 hover:no-underline hover:text-primary transition-colors">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 leading-relaxed text-base pb-6 pt-2 prose prose-slate max-w-none">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </ScrollReveal>
      </div>
    </section>
  )
}
